import React, {useContext} from 'react';
import {Flex, Glyph, Text} from "@qc-modules/components";
import {colors} from "@qc-modules/styles";
import styled from 'styled-components';
import AppContext from "../../../context/AppContext";
import {trackCtaEvent} from "../../../utils/Utils";

const SIGN_OUT_SVG_PATH = "M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z";
const CHIP_SVG_PATH = "M7.875 0.875V2.875M13.875 0.875V2.875M7.875 19.875V20.875M13.875 18.875V20.875M18.875 7.875H20.875M18.875 12.875H20.875M0.875 7.875H2.875M0.875 12.875H2.875M4.875 2.875H16.875C17.9796 2.875 18.875 3.77043 18.875 4.875V16.875C18.875 17.9796 17.9796 18.875 16.875 18.875H4.875C3.77043 18.875 2.875 17.9796 2.875 16.875V4.875C2.875 3.77043 3.77043 2.875 4.875 2.875ZM7.875 7.875H13.875V13.875H7.875V7.875Z";


export const HeaderLabel = (props) => {
  const {appStore} = useContext(AppContext);
  let extraSpace = 0;
  if(props.noGlyphInDesk){
    extraSpace =24
  }

  const StyledGlyph = styled(Glyph)`
    align-items: center;
    justify-content: center;
    fill: ${
    () => props.isActive ?
      colors("blue") :
      colors("white")
  }
`;

  const StyledLabelText = styled(Text)`
    margin-left:${
      () => props.position === "end" ?
          "0px" :
          "12px"
    };
    opacity:${
      () => props.setOpacity ?
          props.setOpacity :
          ""
    };
    cursor: pointer;
    font-family: 'Roboto Flex', sans-serif;
    color: ${
    () => props.isActive ?
      colors("blue") :
      colors("white")
  };
`;

  const AuthHeaderLabel = styled(Flex)`
cursor: pointer;
height: 48px;
border-radius: 50px 0 0 50px;
align-items: center;
width: 100%;
margin-bottom: 17px;
padding-left:${
    ()=> `${42+extraSpace}px`
  } ;
margin-top: ${
    ()=>props.position === 'end'?'auto':'0px'
  };
background-color: ${
    () => props.isActive ?
      "white" :
      "transparent"
  };
    &:hover {cursor: pointer};
`;

  return (
    <AuthHeaderLabel data-test-id={props.id} onClick={() => {
      if (window.location.pathname !== '/profile') {
        window.location = '/profile'
        return
      }
      trackCtaEvent(props.path,  props.pathLabel, {} )
      appStore.setProfileTabPath(props.path);
      appStore.setDisableEdit(false)
    }}>

      {
        !props.noGlyphInDesk && (() => {
          const fill = props.isActive ? colors("blue", {}) : colors("white", {});
          const inlineStyle = {display: 'block', flexShrink: 0, fill};
          if (props.glyphId === 'sign-out') {
            return (
              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={inlineStyle}>
                <path fill="inherit" d={SIGN_OUT_SVG_PATH}/>
              </svg>
            );
          }
          if (props.glyphId === 'chip') {
            return (
              <svg width="24" height="24" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" style={{display: 'block', flexShrink: 0}}>
                <path d={CHIP_SVG_PATH} stroke={fill} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            );
          }
          return <StyledGlyph id={props.glyphId} height="24px" />;
        })()
      }
      <StyledLabelText f={3}>{props.pathLabel}</StyledLabelText>
    </AuthHeaderLabel>
  )
};
